import apiFetch from '../apiFetch'

export default function (idTransportista, token) {
  return apiFetch({endPoint: `Transportista/getTransporte?idTransportista=` + idTransportista, method: 'GET', body: null, token: token})
}